import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';

import { AppProductCarouselComponent } from './app-product-carousel.component';
import { ProductCardModule } from '~shared/modules/product-card/product-card.module';
import { MmIconModule } from '@metromarkets/components';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SwipeModule } from '~shared/directives/swipe/swipe.module';
import { ChevronRightModule } from '~shared/svgs/chevron-right/chevron-right.module';
import { ChevronLeftModule } from '~shared/svgs/chevron-left/chevron-left.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    QaLocatorsModule,
    ProductCardModule,
    MmIconModule,
    CarouselModule,
    SwipeModule,
    ChevronRightModule,
    ChevronLeftModule
  ],
  declarations: [
    AppProductCarouselComponent,
  ],
  exports: [
    AppProductCarouselComponent
  ]
})

export class AppProductCarouselModule {}
